import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';
import './Navbar.css';

const Navbar = () => {
  const { t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userRole = localStorage.getItem('userRole');
  const authAppUrl = process.env.REACT_APP_AUTH_APP_URL || 'https://app.rentplus.dk';

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    window.location.href = '/';
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <img src="/images/logo-Photoroom.png" alt="Rentplus Logo" className="navbar-logo" />
       
        </Link>
        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`navbar-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/about" onClick={() => setMobileMenuOpen(false)}>{t('nav.about', 'About')}</Link>
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>{t('nav.contact', 'Contact')}</Link>
          <Link to="/careers" onClick={() => setMobileMenuOpen(false)}>{t('nav.careers', 'Careers')}</Link>

          <LanguageSelector />
          
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
